import { animate, query, style, transition } from '@angular/animations';

export const fadeUpIfSubtle = [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(10px) translateZ(0)' }),
    animate('0.2s ease', style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0px)' }),
    animate('0.2s ease', style({ opacity: 0, transform: 'translateY(10px) translateZ(0)' })),
  ]),
];
export const fadeUpIfSubtleButtons = [
  transition(':enter', [
    query(
      '.custom-button',
      [
        style({ opacity: 0, transform: 'translateY(10px) translateZ(0)' }),
        animate('0.2s ease', style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' })),
      ],
      { optional: true }
    ),
  ]),
  transition(':leave', [
    query(
      '.custom-button',
      [
        style({ opacity: 1, transform: 'translateY(0px)' }),
        animate('0.2s ease', style({ opacity: 0, transform: 'translateY(10px) translateZ(0)' })),
      ],
      { optional: true }
    ),
  ]),
];
